module.exports = __webpack_public_path__ + "static/Q4Answer2_Loving_Neonbrand-ddada790dfcfe716579ab6cddca69c10.jpg";